import { render, staticRenderFns } from "./order-submit.vue?vue&type=template&id=3f264630&scoped=true"
import script from "./order-submit.vue?vue&type=script&lang=ts"
export * from "./order-submit.vue?vue&type=script&lang=ts"
import style0 from "./order-submit.vue?vue&type=style&index=0&id=3f264630&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f264630",
  null
  
)

export default component.exports